import { render, staticRenderFns } from "./PaymentErrorsList.vue?vue&type=template&id=717e82c7&scoped=true&"
import script from "./PaymentErrorsList.vue?vue&type=script&lang=js&"
export * from "./PaymentErrorsList.vue?vue&type=script&lang=js&"
import style0 from "./PaymentErrorsList.vue?vue&type=style&index=0&id=717e82c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717e82c7",
  null
  
)

export default component.exports